export const ORDER_TABLE_COLUMN_IDS = [
  'orderNumber',
  'account',
  'contact',
  'salesperson',
  'price',
  'orderedOn',
  'shipsOn',
  'deliverBy',
  'payment',
  'po',
] as const;
